import styled from '@emotion/styled/macro';
import vars from '@variables';
import { H1Atom } from '@atoms/text-atoms/text-atoms';
import { defineResponsiveGridColumns } from '@utils/utils';

export const MastheadContainer = styled.div<{
  pageColour?: string;
  hasSecondaryNav?: boolean;
}>`
  width: 100%;
  text-align: center;
  margin-top: 0px;

  @media screen and (min-width: ${vars.breakPointTablet}) {
    margin-top: ${({ hasSecondaryNav }) => (hasSecondaryNav ? '0' : '56px')};
  }
`;

export const Banner = styled.div<{
  isFullHeight: boolean;
  pageColour?: string;
}>`
  position: relative;
  height: ${({ isFullHeight }) => (isFullHeight ? '100vh' : '30vh')};
  min-height: 26rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${({ pageColour }) =>
    pageColour ? pageColour : 'transparent'};
  overflow: hidden;

  @media screen and (min-width: ${vars.breakPointTablet}) {
    min-height: 30rem;
    height: ${({ isFullHeight }) => (isFullHeight ? '100vh' : '50vh')};
  }
`;

export const AlignableContent = styled.div<{
  pageColour?: string;
  align: 'left' | 'right' | 'center';
}>`
  display: flex;
  flex-direction: column;
  align-items: ${({ align }) => {
    switch (align) {
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      default:
        return 'center';
    }
  }};
  justify-content: center;
  z-index: 20;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  max-width: ${vars.mainMaxWidth};
  padding: 0 ${vars.mainContentContainerPaddingMobile};
  gap: 2rem;

  @media screen and (min-width: ${vars.breakPointTablet}) {
    padding: 0 ${vars.spacingL};
    gap: 3.5rem;
  }

  ${H1Atom} {
    margin: 0;
    width: 90%;
    line-height: 1.7;
    text-align: ${({ align }) => align};

    @media screen and (min-width: ${vars.breakPointTablet}) {
      line-height: 1.5;
    }

    span {
      font-weight: ${vars.fontWeightExtraBold};
      color: ${({ pageColour }) => pageColour};
      background-color: white;
      box-shadow:
        ${vars.spacingS} 0 0 white,
        -${vars.spacingS} 0 0 white;
      padding-bottom: 2px;
      -webkit-box-decoration-break: clone;
      box-decoration-break: clone;
      @media screen and (min-width: ${vars.breakPointTablet}) {
        padding-bottom: 4px;
      }
    }
  }
`;

export const VideoWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  video {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
  }
`;

export const GatsbyImageWrapper = styled.div`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  & > div {
    height: 100% !important;
    width: 100% !important;
  }

  img {
    object-fit: cover !important;
    object-position: center !important;
    width: 100% !important;
    height: 100% !important;
  }
`;

export const InnerLogo = styled.div``;

export const MastheadBelowTitle = styled(H1Atom)`
  text-align: left;
  max-width: ${vars.contentMaxWidth};
`;

export const BelowTitleContainer = styled.div`
  max-width: ${vars.contentMaxWidth};
  display: grid;
  column-gap: ${vars.mobileColumnPercentageGap};
  margin: 0px auto;
  grid-template-columns: ${defineResponsiveGridColumns(4)};
  min-width: ${vars.contentMinWidth};
  padding: ${vars.spacingL} ${vars.mainContentContainerPaddingMobile} 0;

  @media screen and (min-width: ${vars.breakPointTenColumn}) {
    padding: ${vars.spacingL} ${vars.mainContentContainerPaddingTenColumn} 0;
  }

  @media screen and (min-width: ${vars.breakPointTablet}) {
    padding: ${vars.spacingL} ${vars.mainContentContainerPaddingTenColumn} 0;
    column-gap: ${vars.standardColumnPercentageGap};
    grid-template-columns: ${defineResponsiveGridColumns(8)};
  }

  @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
    grid-template-columns: ${defineResponsiveGridColumns(12)};
  }

  @media screen and (min-width: ${vars.breakPointTwelveColumn}) {
    padding: ${vars.spacingL} ${vars.spacingL} 0;
  }

  & > * {
    grid-column: 1 / -1; // Full width on mobile

    @media screen and (min-width: ${vars.breakPointTablet}) {
      grid-column: col2-start/col7-end;
    }

    @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
      grid-column: col3-start/col10-end;
    }
  }
`;
